import React, { useEffect, useContext } from "react";
import { Slider, Slide, ButtonBack, ButtonNext } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { CarouselContext } from "pure-react-carousel";
import { Marker } from "./types";
import { ChevronRight, ChevronLeft } from "./icons";

export const LarekSlider = ({
  activeItem,
  currentSlide,
  setCurrentSlide,
}: {
  activeItem: Marker;
  currentSlide: number;
  setCurrentSlide: Function;
}) => {
  const carouselContext = useContext(CarouselContext);

  useEffect(() => {
    carouselContext.subscribe(() => {
      setCurrentSlide(carouselContext.state.currentSlide);
    });
  }, []);

  return (
    <>
      <Slider>
        {activeItem.images.map((item, index) => {
          return (
            <Slide
              key={`${activeItem.id}-${index}`}
              index={index}
              className="panel"
            >
              <div
                style={{
                  background: `url(${item}) no-repeat`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  height: "100%",
                }}
              ></div>
            </Slide>
          );
        })}
      </Slider>
      <div className="flex gap-2 mt-4 text-2xl font-medium">
        <ButtonBack>
          <ChevronLeft />
        </ButtonBack>
        <div>
          {currentSlide + 1} / {activeItem.images.length}
        </div>
        <ButtonNext
          onClick={() => {
            setCurrentSlide(currentSlide + 1);
          }}
        >
          <ChevronRight />
        </ButtonNext>
      </div>
    </>
  );
};
